import R from 'ramda';

import accordionTemplate from './accordion.tpl.html';

export class Accordion {
  getLabel() {
    const fieldGroupItemTemplate = R.find(
      R.propEq('type', 'field'),
      R.values(this.template.contiguousItemsWithSameType));
    const fieldsHeaderTemplate = R.filter(
      R.pathEq(['attrs', 'header'], true),
      (fieldGroupItemTemplate && fieldGroupItemTemplate.items) || []);

    if (R.isEmpty(fieldsHeaderTemplate)) {
      const fieldItemTemplate = R.head(
        (fieldGroupItemTemplate && fieldGroupItemTemplate.items) || []);

      return !fieldItemTemplate || !this.data || !this.data.fields[fieldItemTemplate.id] ||
        !this.data.fields[fieldItemTemplate.id].value
        ? '-'
        : this.data.fields[fieldItemTemplate.id].value;
    }

    const tabLabel = fieldsHeaderTemplate
      .map(field =>
        (this.data && this.data.fields[field.id] && this.data.fields[field.id].value) || null)
      .filter(value => !R.isNil(value))
      .map(value => R.trim(value))
      .join(' - ');

    return !R.isEmpty(tabLabel)
      ? tabLabel
      : '-';
  }

  isEditMode() {
    return !R.isNil(this.editMode) && this.editMode;
  }

  removeAccordion(e) {
    e.stopPropagation();
    e.preventDefault();
    this.onRemoveAccordion();
  }
}

export const tctAccordion = {
  template: accordionTemplate,
  controller: Accordion,
  bindings: {
    template: '<',
    data: '<',
    editMode: '<?',
    onRemoveAccordion: '&',
  },
};
